const CARVE = "CARVE";
const WRITE = "WRITE";

export default class OrderFormOption {
  // Step 5
  get carve () {
    return CARVE;
  }
  get write () {
    return WRITE;
  }

  get tabletTypes () {
    return [
      {
        label: "通常位牌",
        value: "通常位牌",
        isMindAlte: false,
      },
      {
        label: "俗名位牌",
        value: "俗名位牌",
        isMindAlte: false,
      },
      {
        label: "マインドアルテ",
        value: "マインドアルテ",
        isMindAlte: true,
      },
    ];
  }

  get addOrNot () {
    return [
      { label: "入れる", value: true },
      { label: "入れない", value: false },
    ];
  }

  getAddOrNotText (isAdded) {
    const orderFormOption = new OrderFormOption();
    const result = orderFormOption.addOrNot.filter(
      el => el.value === isAdded
    )[0];
    if (result === undefined) {
      return "入れない";
    }
    return result.label;
  }

  get includedOrNot () {
    return [{ label: "あり", value: true }, { label: "なし", value: false }];
  }

  get secularNameSuffixes () {
    return [
      { label: "A", value: "A" },
      { label: "B", value: "B" },
      { label: "C", value: "C" },
    ];
  }

  get nameCounts () {
    return [{ label: "1霊", value: 1 }, { label: "2霊", value: 2 }];
  }

  get printTypes () {
    return [
      { label: "戒名彫り", value: CARVE },
      { label: "戒名書き", value: WRITE },
    ];
  }
  get fontsForCarve () {
    return [
      { label: "手彫り風書体", value: "手彫り風書体", disabled: true },
      { label: "楷書体", value: "標準書体", disabled: true },
    ];
  }
  get fontsAll () {
    return [
      { label: "手彫り風書体", value: "手彫り風書体", disabled: true },
      { label: "楷書体", value: "標準書体", disabled: true },
      { label: "機械書", value: "合掌体", disabled: true },
      { label: "手書き", value: "手書き", disabled: true, annotation: "注1" },
      { label: "SK書体", value: "SK書体", disabled: true },
      { label: "機械書(手彫風書体)", value: "機械書手彫風書体", disabled: true },
    ];
  }

  get colorsForFront () {
    return [
      { label: "金色", value: "GOLD", disabled: true },
      { label: "白色", value: "WHITE", disabled: true },
      { label: "朱色", value: "RED", disabled: true },
      { label: "金箔", value: "GOLD_FILM", disabled: true },
      { label: "黒色", value: "BLACK", disabled: true },
    ];
  }

  get colorsForBack () {
    return [
      { label: "金色", value: "GOLD", disabled: true },
      { label: "白色", value: "WHITE", disabled: true },
      { label: "朱色", value: "RED", disabled: true },
      { label: "金箔", value: "GOLD_FILM", disabled: true },
      { label: "黒色", value: "BLACK", disabled: true },
    ];
  }

  getPrintType (printType) {
    switch (printType) {
      case CARVE:
        return "戒名彫り";
      case WRITE:
        return "戒名書き";
    }
    return "";
  }

  getColor (color) {
    switch (color) {
      case "GOLD":
        return "金色";
      case "WHITE":
        return "白色";
      case "GOLD_FILM":
        return "金箔";
      case "BLACK":
        return "黒色";
      default:
        return "朱色";
    }
  }

  getColorCodeBasedOnColorName (colorName) {
    switch (colorName) {
      case "GOLD":
      case "GOLD_FILM":
        return "yellow";
      case "WHITE":
        return "white";
      case "RED":
        return "red";
      case "BLACK":
        return "black";
      default:
        return "";
    }
  }

  // Step 6
  // 位表記の配置ルール取得
  get underCharactersPlacement () {
    return [
      { label: "未選択", value: "" },
      { label: "中心", value: "CENTER" },
      { label: "霊ごと", value: "EACH_COLUMN" },
    ];
  }

  // 俗名の配置ルール取得
  get secularNamePrefixPlacement () {
    return [
      { label: "未選択", value: "" },
      { label: "中心", value: "CENTER" },
      { label: "霊ごと", value: "EACH_COLUMN" },
    ];
  }

  // 享年の配置ルール取得
  get ageAtDeathPrefixPlacement () {
    return [
      { label: "未選択", value: "" },
      { label: "中心", value: "CENTER" },
      { label: "霊ごと", value: "EACH_COLUMN" },
    ];
  }

  get sects () {
    return [
      { label: "曹洞宗", value: true },
      { label: "法華", value: false },
      { label: "日蓮", value: false },
      { label: "浄土真宗", value: false },
      { label: "天台宗", value: false },
      { label: "真言宗", value: false },
      { label: "禅宗", value: false },
    ];
  }

  get diedCharacters () {
    return [
      { label: "没", value: "没" },
      { label: "往生", value: "往生" },
      { label: "逝去", value: "逝去" },
      { label: "寂", value: "寂" },
      { label: "帰霊", value: "帰霊" },
      { label: "その他", value: "その他" },
    ];
  }

  get ageAtDeathPrefixes () {
    return [
      { label: "享年", value: "享年" },
      { label: "行年", value: "行年" },
      { label: "天寿", value: "天寿" },
      { label: "満", value: "満" },
      { label: "その他", value: "その他" },
    ];
  }

  get ageUnitCharacters () {
    return [
      { label: "才", value: "才" },
      { label: "歳", value: "歳" },
      { label: "その他", value: "その他" },
    ];
  }

  get sanskritCharacterOrFamilyEmblem () {
    return [
      { label: "未選択", value: null },
      { label: "入れない", value: "NO_NEED" },
      { label: "梵字", value: "SANSKRIT_CHARACTER" },
      { label: "家紋", value: "FAMILY_EMBLEM" },
    ];
  }

  get underCharacters () {
    return [
      { label: "入れない", value: "" },
      { label: "位", value: "位" },
      { label: "之位", value: "之位" },
      { label: "之霊位", value: "之霊位" },
      { label: "霊", value: "霊" },
      { label: "霊位", value: "霊位" },
    ];
  }
}
